import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import './LandingHeader.css';

const LandingHeader = (props) => {
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1000);
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleAboutNav = async () => {
        navigate("/about");
    }

    const handleServicesNav = async () => {
        navigate("/");
    }

    const handleFaqNav = async () => {
        navigate("/faq");
    }

    const handleBlogNav = async () => {
        navigate("/blog");
    }

    const handleDemoNav = async () => {
        navigate("/demo");
    }

    const handleSignInNav = async () => {
        navigate("/login");
    }

    return (
        <header className='landing-header'>
            <div className='content' style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between'
            }}>
                {/* Left Section - Logo (hidden on mobile) */}
                {!isMobile && (
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                        <img src={require('../../images/logo-dark.png')} alt='Logo' onClick={handleServicesNav} className='logo' />
                    </div>
                )}

                {/* Center Section - Navigation Links */}
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    gap: '40px',
                    flex: isMobile ? 1 : 'auto'
                }}>
                    {/* <p onClick={handleAboutNav} className={(props.page === "about" ? "link curr-page" : "link")}>About Us</p> */}
                    <p onClick={handleServicesNav} className={(props.page === "services" ? "link curr-page" : "link")}>Our Services</p>
                    <p onClick={handleFaqNav} className={(props.page === "faq" ? "link curr-page" : "link")}>FAQ</p>
                    <p onClick={handleDemoNav} className={(props.page === "demo" ? "link curr-page" : "link")}>Demo</p>
                    {/* <p onClick={handleBlogNav} className={(props.page === "blog" ? "link curr-page" : "link")}>Blog</p> */}
                </div>

                {/* Right Section - Sign In Button (hidden on mobile) */}
                {!isMobile && (
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                        <p className='blue-btn' onClick={handleSignInNav}>Sign In</p>
                    </div>
                )}
            </div>
        </header>
    )
}

export default LandingHeader;